export default {
	add: 'add',
	search_tips: 'Matters needing attention',
	booth_info: '1. Selection of Insurance Booth',
	boothNo: 'booth number',
	boothNo_input: 'Please select the insurance booth (which can be inputted and retrieved)',
	input_tips_first: 'Enter the booth number in the left input box, click the Search button, and wait for the search.',
	input_tips_second: 'Click on the result to select it. When selected, it will be displayed below',
	input_tips_title: 'How to choose a booth',
	search: 'Search',
	selected_booth: 'Selected Booth',
	query_booth: 'Query',
	import_booth: 'Import booth number',
	non_selection: 'You have not selected a booth that needs to purchase insurance',
	remove_confirm: 'confirm delete',
	remove_btn: 'delete',
	non_search_booth: 'No booth number you entered was queried',
	company_info: '2. Fill in company information',
	taxCode: 'Insured company taxCode',
	form_taxCode_check: 'Please enter the correct taxCode',
	form_taxCode_text: 'Please enter the taxCode',
	companyName: 'Insured company name',
	form_companyName_check: 'Please enter the name of the insured company',
	contact_person_name: 'Contact Person name',
	form_contactPerson_check: 'Please enter a contact Person name',
	phone: 'phone',
	form_phone_check: 'Please enter the correct phone number',
	form_phone_placeholder: 'Please enter the contact Person phone number',
	email: 'email',
	form_email_check: 'Please enter the contact email',
	form_email_placeholder: 'Please enter the email',
	user_info: 'Existing contact information',
	user_info_tips: 'Can be checked directly',
	goto_buy: 'Start buying',
	select: 'choose',
	booth_area: 'booth area',
	actions: 'action',
	net_error: 'Failed to get information, please refresh and try again',
	non_search_booth_tips: 'There is no booth number you have inquired at the exhibition. Please check if the booth number is correct and re-enter',
	taxCode_tips_title: 'Tips',
	taxCode_tips: 'Invoice Tax Number/Tax Identification Number information does not match the company name, please confirm whether the input is correct.',
	competed_tips: 'Already purchased? If there is no insurance purchase interface, please ',
    "点击此处":"click here",
	competed: 'carry out',
	carry_on: 'Continue to buy',
	'展位类型':'Booth Type',
	'参展商':'Exhibitor',
	'参展商联系人':'Exhibitor Contacts',
	'电话':'Phone number',
	'邮箱':'Mail',
	'传真':'Fax',
	'备注':'Remarks',
	//1686ui优化
	'购买保险': 'Buy insurance',
	'目前仅支持购买展会保（展览会责任险）;':'At present, only support the purchase of exhibition insurance (exhibition liability insurance);',
	'一次下单仅支持用一个公司购买保险;':'One order only supports the purchase of insurance by one company.',
	'如您的展位面积包含小数，系统将会按整数计算（舍去小数位），不影响投保;':'If your booth area contains decimal, the system will be calculated by integer (excluding decimal), without affecting insurance;',
	'一次购买保险的展位数量最多不能超过5个，如有多个请分批购买;':'The number of exhibitions for one purchase of insurance should not exceed 5 at most. If there are more than one, please purchase in batches.',
	'请务必保证填写信息的真实性和准确性，如因信息填写有误造成的后果由客户自行承担。':'Please ensure the authenticity and accuracy of the information, if the consequences of incorrect information filling are borne by the customers themselves.',
	'已选择':'',
	'个展位，最多可选择':' booths have been selected and up to ',
	'个展位':' booths can be selected.',
	'公司名称':'Corporate name',
	'展位号':'Booth Number',
	'展位面积（㎡）':'Booth area（㎡）',
	'操作':'operation',
	'使用此联系人信息':'use this info',
	'未查询到您输入的展位号，您可以':'No booth number you entered was queried, you can',
	'添加展位':'Adding booths',
	'确定':'Determine',
	'取消':'cancel',
	'展会未配置保险承保方案':'No insurance scheme for the exhibition',

}




// WEBPACK FOOTER //
// ./src/i18n/en-us/insuranceHome.js